import React from 'react';
import type { BillingCycle } from './tiersData';

interface PricingHeroProps {
  billingCycle: BillingCycle;
  onCycleChange: (cycle: BillingCycle) => void;
}

export const PricingHero: React.FC<PricingHeroProps> = ({ billingCycle, onCycleChange }) => {
  const isAnnual = billingCycle === 'annual';

  return (
    <header className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
        Preços simples e diretos
      </h1>
      <p className="text-base sm:text-lg text-neutral-400 mb-8 sm:mb-10">
        Comece grátis. Assine quando estiver pronto. Sem surpresas, sem taxas escondidas.
      </p>

      <div
        role="group"
        aria-label="Alternar entre cobrança mensal ou anual"
        className="inline-flex items-center gap-1 p-1 rounded-full bg-neutral-900/80 border border-neutral-700/50 backdrop-blur-xl"
      >
        <button
          type="button"
          role="switch"
          aria-checked={!isAnnual}
          onClick={() => onCycleChange('monthly')}
          className={`min-h-[44px] px-5 sm:px-6 rounded-full text-sm font-medium transition-colors ${
            !isAnnual
              ? 'bg-primary-600 text-white'
              : 'text-neutral-300 hover:text-white'
          }`}
        >
          Mensal
        </button>
        <button
          type="button"
          role="switch"
          aria-checked={isAnnual}
          onClick={() => onCycleChange('annual')}
          className={`min-h-[44px] px-5 sm:px-6 rounded-full text-sm font-medium transition-colors flex items-center gap-2 ${
            isAnnual
              ? 'bg-primary-600 text-white'
              : 'text-neutral-300 hover:text-white'
          }`}
        >
          Anual
          <span
            className={`px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide ${
              isAnnual ? 'bg-emerald-400 text-neutral-950' : 'bg-emerald-500/20 text-emerald-300'
            }`}
          >
            20% OFF
          </span>
        </button>
      </div>
    </header>
  );
};
